"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUpgradeProduct = void 0;

var UpgradeProducts = _interopRequireWildcard(require("self-service-api/constants/UpgradeProducts"));

var _validateProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty");

var validateUpgradeProduct = function validateUpgradeProduct(upgradeProduct) {
  var upgradeProductValues = Object.values(UpgradeProducts);
  var isValidUpgradeProduct = upgradeProductValues.indexOf(upgradeProduct) !== -1;
  return (0, _validateProperty.validateProperty)(isValidUpgradeProduct, "expected upgradeProduct to be one of " + upgradeProductValues + " but got " + upgradeProduct, 'upgradeProduct');
};

exports.validateUpgradeProduct = validateUpgradeProduct;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/data/upgradeData/validators/validateUpgradeProduct.js
// module id = 667
// module chunks = 5 6